// Unauthorized.tsx
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const Unauthorized: React.FC = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const message =
		(location.state as { message?: string })?.message || 'Accès non autorisé.';

	return (
		<div className="flex items-center justify-center min-h-screen bg-gray-100 p-4">
			<div className="bg-white rounded-2xl shadow-lg p-10 max-w-md text-center">
				<h1 className="text-6xl font-bold text-red-600 mb-4">401</h1>
				<h2 className="text-2xl font-semibold mb-4">Accès non autorisé</h2>
				<p className="text-gray-600 mb-8">{message}</p>
				<button
					onClick={() => navigate('/login', { replace: true })}
					className="bg-red-600 hover:bg-red-700 text-white font-semibold py-2 px-6 rounded-lg transition-colors duration-200"
				>
					Retour à la connexion
				</button>
			</div>
		</div>
	);
};

export default Unauthorized;
